/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmspost_Published_At1Inputs */

const vi_cmspost_published_at1 = /** @type {(inputs: Cmspost_Published_At1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ngày đăng`)
};

/**

* @param {Cmspost_Published_At1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cmspost_published_at1 = /** @type {((inputs?: Cmspost_Published_At1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmspost_Published_At1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cmspost_published_at1(inputs)
});
export { cmspost_published_at1 as "cmsPost_published_at" }